import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  MenuItem,
  FormControl,
  InputLabel,
  Select
} from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import { Alerts } from "../../../components/alerts/Alerts.tsx";
import { useReassignmentDialog } from "../../hooks/delivery/useReassignmentDialog.tsx";

const reassignmentSchema = yup.object().shape({
  origin_route: yup.string().required("Ruta requerida"),
  delivery_date: yup.string().required("Fecha requerida"),
  reason: yup.string().required("Motivo requerido")
});

const ReassignmentDialog = ({ openReassignmentDialog, onClose, routesListData, tempsValues, id_box_recibe, isDelivery }) => {

  const {
    alertSuccess,
    showErrorRequest,
  } = Alerts();

  const {
    reassignmentRegister
  } = useReassignmentDialog(showErrorRequest);

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      if (isDelivery) {
        if (tempsValues.origin_route === values.origin_route && tempsValues.delivery_date === values.delivery_date + ' 00:00:00') {
          showErrorRequest('No se puede asignar la misma fecha y la misma ruta que tiene  actualmente', null);
          return;
        }
      }
      console.log('val', values)
      let rest = reassignmentRegister(values);


      // Cierra el diálogo después de guardar
      alertSuccess('Registro Reasignado', 'Se a reasignado el registro correctamente', undefined);
      onClose();
    } catch (error) {
      console.error("Error al reasignar:", error);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog open={openReassignmentDialog} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Reasignar Delivery</DialogTitle>
      <Formik
        initialValues={{
          origin_route: "",
          delivery_date: "",
          reason: "",
          id_box: id_box_recibe,
          pickup_user_id: tempsValues.pickup_user_id,
          delivery_user_id: tempsValues.delivery_user_id,
          status: tempsValues.status
          //id_box_size: tempsValues.id_box_size,
        }}
        validationSchema={reassignmentSchema}
        onSubmit={handleSubmit}
      >
        {({
          values,
          handleChange,
          handleBlur,
          handleSubmit,
          touched,
          errors,
          isSubmitting
        }) => (
          <form onSubmit={handleSubmit}>
            <DialogContent sx={{ display: "grid", gap: 2 }}>
              <FormControl variant="filled" required>
                <InputLabel id="select-route-label">Ruta asignada</InputLabel>
                <Select
                  labelId="select-route-label"
                  id="select-route"
                  name="origin_route"
                  value={values.origin_route}
                  onChange={handleChange}
                  onBlur={handleBlur}
                >
                  {routesListData?.map((route) => (
                    <MenuItem key={route.id} value={route.id.toString()}>
                      {route.route_name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <TextField
                fullWidth
                variant="filled"
                type="date"
                label="Fecha Delivery"
                name="delivery_date"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.delivery_date}
                error={!!touched.delivery_date && !!errors.delivery_date}
                helperText={touched.delivery_date && errors.delivery_date}
              />

              <TextField
                fullWidth
                multiline
                variant="filled"
                label="Motivo de Reasignación"
                name="reason"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.reason}
                error={!!touched.reason && !!errors.reason}
                helperText={touched.reason && errors.reason}
              />
            </DialogContent>

            <DialogActions>
              <Button onClick={onClose} color="inherit">
                Cancelar
              </Button>
              <Button type="submit" variant="contained" color="primary" disabled={isSubmitting}>
                Guardar
              </Button>
            </DialogActions>
          </form>
        )}
      </Formik>
    </Dialog>
  );
};

export default ReassignmentDialog;
